import PartnerSelection from 'components/Categories/PartnerSelection';
import ApiKeyProvider, { useApiKey } from 'hooks/ApiKey';
import { useState } from 'react';
import ApiKeyList from './ApiKeyList';
import ButtonWithIcon from 'components/ButtonWithIcon/ButtonWithIcon';
import AddIcon from 'assets/icons/AddIcon';
import { useModal } from 'hooks/Modal';
import StyledModal, {
  ModalType,
} from 'components/Modal/styledModal/StyledModal';
import { useMemoTranslations } from 'hooks/Intl';
import * as translations from 'intls/apiKey';
import * as modalTranslations from 'intls/modals';
import { apiKeyService } from 'services';

const ApiKeyManagement = () => {
  return (
    <ApiKeyProvider>
      <Content />
    </ApiKeyProvider>
  );
};

const Content = () => {
  const { actions } = useModal();
  const { partners, fetchApiKeys } = useApiKey();
  const intl = useMemoTranslations(translations);
  const intlModals = useMemoTranslations(modalTranslations);

  const [partner, setPartner] = useState(partners?.[0]);

  const createKey = async () => {
    try {
      actions.showLoading();

      await apiKeyService.create(partner.partner_id);

      actions.hideLoading();
      actions.showModal(
        '',
        <StyledModal
          type={ModalType.SUCCESS}
          title={intl.KEY_CREATED_SUCCESSFULLY}
        />,
        false
      );
    } catch (error) {
      actions.hideLoading();
      actions.showModal(
        '',
        <StyledModal
          type={ModalType.ERROR}
          title={intlModals.UNEXPECTED_ERROR}
        />,
        false
      );
    } finally {
      fetchApiKeys();
    }
  };

  const openConfirmCreateModal = () => {
    actions.showModal(
      '',
      <StyledModal
        title={intl.CREATE_KEY_CONFIRMATION}
        type={ModalType.CONFIRMATION}
        textConfirm={intl.LABEL_CONFIRM_CREATE_KEY}
        onClickConfirm={createKey}
        onClickDeny={actions.closeModal}
      />,
      true
    );
  };

  return (
    <>
      <PartnerSelection
        partners={partners}
        selected={partner}
        select={setPartner}
      />
      {!!partner && (
        <ButtonWithIcon
          Icon={AddIcon}
          label={intl.ADD_KEY_FOR_PARTNER}
          onClick={openConfirmCreateModal}
        />
      )}
      <ApiKeyList />
    </>
  );
};

export default ApiKeyManagement;
